import { Mission } from '../../lib/types/models/mission/mission'
import { MissionRequest } from '../../lib/types/models/mission/mission-input'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function createMission(data: MissionRequest) {
  return restApiClient
    .url(constructApiUrl(API.missions.create.url, null))
    .post<Mission, MissionRequest>(data)
}
